import React, { useState, useEffect } from 'react';
import ErpTemplate from '../../../components/ErpTemplate';
import { FaSave, FaBackward, FaThumbsUp, FaThumbsDown, FaPlaneDeparture, FaPlaneArrival } from 'react-icons/fa';
import api from '../../../services/api';
import { useHistory, useLocation } from 'react-router-dom';
import {
    dataMysql,
    extract,
    parseCamposQuestionario,
    getOpcaoIdaSalva as montarOpcaoIdaSalva,
    getOpcaoRetornoSalva as montarOpcaoRetornoSalva,
    idaTemDados,
    retornoTemDados,
} from '../../../util/util';
import ReactSelect from '../../../components/ReactSelect';
import NavItem from '../../../components/NavItem';
import InputMask from 'react-input-mask';
import { toast } from 'react-toastify';
import moment from 'moment';
import Alert from '../../../components/Alert';
import { getText, getIdiomaCodigo } from '../../../util/translations';
import { getAuthPerfil, getAuthToken } from '../../../util/authSession';
import UploadDropzone from '../../../components/UploadDropzone';
import { FinField } from '../../../components/FinField';
import LocalAereo from '../../../components/LocalAereo';
import '../../../css/financeiro-parcela-pagar.css';
import { rotaDoStep, irParaProximoStep } from '../../../util/fluxoConvite';
import '../../../css/aereo-opcoes.css';

// Equipe que pode trocar a escolha de voo por aqui. Só para ela aparece a confirmação de troca
// depois do envio para emissão; o convidado (e o cliente) não.
const PERFIS_EQUIPE_EMISSAO = ['admin', 'diretor', 'gerenteprojeto', 'rsvp', 'gerentersvp', 'coordenadorrsvp', 'operadorrsvp', 'evento', 'gerenteevento', 'gerenteeventointernacional'];


export default function CadastroEventoParticipanteAereoConvite({ match }) {
    const id = match.params.id;
    const token = getAuthToken();
    const perfil = getAuthPerfil();
    const contrato = new URLSearchParams(window.location.search).get('contrato');
    const [data, setData] = useState(null);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [isError, setIsError] = useState(false);
    const [marcadoIda, setMarcadoIda] = useState(null);
    const [cidadeOrigem, setCidadeOrigem] = useState('');
    const [marcadoRetorno, setMarcadoRetorno] = useState(null);
    const [aereoNaoAtendeIda, setAereoNaoAtendeIda] = useState(false);
    const [aereoNaoAtendeVolta, setAereoNaoAtendeVolta] = useState(false);
    // "Não utilizarei esse trecho" (fluxo nacional): escolha terminal do trecho, sem reoferta — o back
    // confirma o participante normalmente. Exige justificativa, gravada na observação do próprio trecho
    // (mesmo campo do "aéreo não me atende"), mas ali como motivo e não como objeção.
    // Espelhado no backend (escolhaAereo).
    const [naoUtilizarIda, setNaoUtilizarIda] = useState(false);
    const [naoUtilizarVolta, setNaoUtilizarVolta] = useState(false);
    const [documentosEntradaPaisCiente, setDocumentosEntradaPaisCiente] = useState(false);
    // Declaração escrita sobre os documentos de entrada no país. O checkbox sozinho passava batido e o
    // convidado chegava no aeroporto sem o documento; escrever o que tem/o que falta é o que o RSVP
    // repassa ao laboratório antes da emissão. Diferente do ciente, este valor volta preenchido: é
    // texto que ele já escreveu, não uma marcação a refazer.
    const [pendenciaDocumentosEntradaPais, setPendenciaDocumentosEntradaPais] = useState('');
    const [arquivoPassaporte, setArquivoPassaporte] = useState(null);
    const history = useHistory();
    let { state } = useLocation();
    //var idEvento = state?.evento ?? null;
    const idioma = getIdiomaCodigo();
    // Override: participante com idioma inglês é SEMPRE tratado como internacional (mesmo em evento
    // nacional) — mostra a visualização internacional, exige cópia de passaporte, etc. Espelhado no backend.
    // O show() carrega a relação Idioma, então data.idioma vem como objeto { codigo, nome }; fallback p/ string.
    const participanteIdiomaCodigo = data?.idioma?.codigo ?? data?.idioma ?? '';
    const participanteIngles = participanteIdiomaCodigo === 'ingles';
    const isInternacional = participanteIngles || (data?.evento?.nacionalidade ?? 'nacional') !== 'nacional';
    const modeloClienteString = data?.evento?.cliente?.modelo ?? 'master';
    const isSanofiModelo = modeloClienteString === 'sanofi';
    const renderCampoAereo = (valor) => (valor ?? '').split("|").map((item, index) => <React.Fragment key={index}>{item}<br /></React.Fragment>);

    // --- Cards responsivos (mobile) das opções de aéreo ---------------------
    // No desktop a tabela original é mantida; abaixo de 768px (Bootstrap
    // `d-md-none`) cada opção vira um card com todos os campos visíveis, para
    // eliminar o scroll horizontal escondido dentro do bloco da tabela.
    // Só apresentação: reaproveitam os mesmos labels (getText) e dados da tabela.
    // Origem e destino pelo `LocalAereo`, como na tabela: cada perna numa linha só, e a cortada abre
    // inteira no popover.
    const camposTrecho = (row, p) => ([
        [getText('data'), row?.[p + 'data']],
        [getText('voo'), row?.[p + 'voo']],
        [getText('origem'), row?.[p + 'origem'], true],
        [getText('destino'), row?.[p + 'destino'], true],
        [getText('saida'), row?.[p + 'horasaida']],
        [getText('chegada'), row?.[p + 'horachegada']],
    ]);

    const renderGridTrecho = (campos) => (
        <dl className="aereo-opc__grid">
            {campos.map(([label, valor, local], i) => (
                <React.Fragment key={i}>
                    <dt>{label}</dt>
                    <dd>{local ? <LocalAereo valor={valor} /> : renderCampoAereo(valor)}</dd>
                </React.Fragment>
            ))}
        </dl>
    );

    // O card é o `label` de um rádio do navegador: o toque em qualquer parte dele marca a opção. O
    // desabilitado (bloqueado, ou a escolha salva fora da lista) fica sem grupo (`name`), para não
    // desmarcar a escolha de outro card.
    const classeDoCard = (checked, disabled) => `aereo-opc__card${checked ? ' is-selected' : ''}${disabled ? ' is-disabled' : ''}`;

    // Card de um trecho único (Ida ou Volta) — fluxo nacional.
    const renderCardNacional = ({ key, row, prefixo, checked, disabled, onSelect }) => (
        <label key={key} className={classeDoCard(checked, disabled)}>
            <div className="aereo-opc__head">
                <input type="radio" className="aereo-opc__radio" name={disabled ? undefined : `aereo-opc-${prefixo}`}
                    checked={checked} disabled={disabled} onChange={onSelect} />
                <span className="aereo-opc__title">{renderCampoAereo(row?.[prefixo + 'companhia'])}</span>
            </div>
            {renderGridTrecho(camposTrecho(row, prefixo))}
        </label>
    );

    // Card combinado Ida + Retorno — fluxo internacional (mesma opção seleciona os dois trechos).
    const renderCardInternacional = ({ key, idaRow, retornoRow = idaRow, checked, disabled, onSelect }) => (
        <label key={key} className={classeDoCard(checked, disabled)}>
            <div className="aereo-opc__head">
                <input type="radio" className="aereo-opc__radio" name={disabled ? undefined : 'aereo-opc-internacional'}
                    checked={checked} disabled={disabled} onChange={onSelect} />
            </div>
            <div className="aereo-opc__section">{getText('ida')}</div>
            {renderGridTrecho(camposTrecho(idaRow, 'ida'))}
            <div className="aereo-opc__section">{getText('retorno')}</div>
            {renderGridTrecho(camposTrecho(retornoRow, 'retorno'))}
        </label>
    );

    const getOpcaoIdaSalva = (dados = data) => montarOpcaoIdaSalva(dados);
    const getOpcaoRetornoSalva = (dados = data) => montarOpcaoRetornoSalva(dados);

    const getIdaRetornoSelecionado = () => {
        if (marcadoIda !== null && String(marcadoIda) === String(marcadoRetorno)) {
            return marcadoIda;
        }

        const opcaoIdaSalva = getOpcaoIdaSalva();
        const opcaoRetornoSalva = getOpcaoRetornoSalva();
        return opcaoIdaSalva?.id && String(opcaoIdaSalva.id) === String(opcaoRetornoSalva?.id)
            ? opcaoIdaSalva.id
            : null;
    };

    const buscar = () => {
        setIsLoading(true);
        setIsError(false);
        api({
            method: "get",
            action: '/participante/' + id,
            token: token,
        }).then(response => {
            //extrai dados internos para o array principal
            var dadosRecebidos = extract({
                jsonLaravel: response.data.data,
                chaves: [
                    'enderecopais',
                    'aereomunicipioembarque',
                    'enderecomunicipio',
                    'banco',
                ]
            });

            //o back decide a etapa (proximoStep). Se esta tela ('aereo') não é a etapa atual, redireciona.
            if (dadosRecebidos.proximoStep !== 'aereo') {
                history.push(rotaDoStep(dadosRecebidos.proximoStep, { id, eventoId: dadosRecebidos.evento.id, contrato }));
                return;
            }

            dadosRecebidos.evento.camposQuestionario = parseCamposQuestionario(dadosRecebidos?.evento?.camposQuestionario);
            dadosRecebidos.passaporteArquivo = dadosRecebidos.passaportearquivo ?? null;
            delete dadosRecebidos.passaportearquivo;

            // Observação de OBJEÇÃO é do acesso anterior: o convidado voltou para escolher de novo, então
            // o campo começa em branco. Observação de trecho RECUSADO é a justificativa e continua
            // valendo — volta preenchida no campo, como qualquer texto que ele já escreveu.
            if (!dadosRecebidos.naoutilizaraereoida) {
                delete dadosRecebidos.aereoidaobservacao;
            }
            if (!dadosRecebidos.naoutilizaraereoretorno) {
                delete dadosRecebidos.aereoretornoobservacao;
            }
            const opcaoIdaSalva = getOpcaoIdaSalva(dadosRecebidos);
            const opcaoRetornoSalva = getOpcaoRetornoSalva(dadosRecebidos);
            setMarcadoIda(opcaoIdaSalva?.id ?? null);
            setMarcadoRetorno(opcaoRetornoSalva?.id ?? null);
            setNaoUtilizarIda(!!dadosRecebidos?.naoutilizaraereoida);
            setNaoUtilizarVolta(!!dadosRecebidos?.naoutilizaraereoretorno);
            setCidadeOrigem(opcaoIdaSalva?.idaorigem ?? dadosRecebidos?.aereoidaorigem ?? '');
            setPendenciaDocumentosEntradaPais(dadosRecebidos?.pendenciadocumentosentradapais ?? '');
            setData(dadosRecebidos);

            // Segunda chamada para buscar dados completos do evento (incluindo RSVP)
            if (dadosRecebidos.evento?.id) {
                api({
                    method: "get",
                    action: '/evento/' + dadosRecebidos.evento.id,
                    token: token,
                }).then(response => {
                    const dadosEvento = response.data.data;
                    if (dadosEvento) {
                        // Atualizar os dados do evento com as informações completas
                        setData(prevDados => ({
                            ...prevDados,
                            evento: {
                                ...prevDados.evento,
                                nacionalidade: dadosEvento.nacionalidade,
                                // texto específico do participante (cadastro interno) sobrepõe o padrão do evento
                                documentosnecessariosentradapais: prevDados.documentosentradapais || dadosEvento.documentos_entrada_pais || ''
                            }
                        }));
                    }
                }).catch(err => {
                    console.log('Erro ao buscar dados do evento:', err);
                }).finally(() => {
                    setIsLoading(false);
                });
            } else setIsLoading(false);
        }).catch(err => {
            setIsLoading(false);
            setIsError(true);
            toast.error(`${getText('error')} ${getText('errorLoadingDefault')}`);
        });
    };//buscar

    const validar = async () => {
        // Validação para documentos necessários para entrada no país - PRIMEIRA VALIDAÇÃO
        // usa o isInternacional override-aware (inclui participante inglês em evento nacional)
        const temDocumentosEntradaPais = (data?.evento?.documentosnecessariosentradapais ?? '').trim() !== '';
        // "não utilizarei a viagem" (internacional) dispensa ciente-documentos e passaporte — sem viagem.
        const naoUtilizarViagem = isInternacional && naoUtilizarIda && naoUtilizarVolta;

        if (isInternacional && !naoUtilizarViagem && temDocumentosEntradaPais && !documentosEntradaPaisCiente) {
            toast.error(getText('requiredCienteDocumentos'));
            return false;
        }

        // A declaração escrita é obrigatória junto com o ciente — mesma condição de exibição do bloco,
        // para não travar quem nunca viu o campo (nacional, evento sem relação de documentos ou viagem
        // recusada).
        if (isInternacional && !naoUtilizarViagem && temDocumentosEntradaPais && pendenciaDocumentosEntradaPais.trim() === '') {
            toast.error(getText('requiredPendenciaDocumentos'));
            return false;
        }

        // usa o isInternacional override-aware do escopo do componente (inclui participante inglês)
        const temPassaporteArquivo = !!(arquivoPassaporte || data?.passaporteArquivo?.id);
        const opcaoIdaSalva = getOpcaoIdaSalva();
        const opcaoRetornoSalva = getOpcaoRetornoSalva();
        const trechoIdaTravado = !!opcaoIdaSalva;
        const trechoRetornoTravado = !!opcaoRetornoSalva;
        const escolhaIdaRetorno = getIdaRetornoSelecionado();
        const escolhaIda = isInternacional ? escolhaIdaRetorno : (marcadoIda ?? opcaoIdaSalva?.id ?? null);
        const escolhaRetorno = isInternacional ? escolhaIdaRetorno : (marcadoRetorno ?? opcaoRetornoSalva?.id ?? null);
        const motivoIdaInformado = (data?.aereoidaobservacao ?? '').trim() !== '';
        const motivoVoltaInformado = (data?.aereoretornoobservacao ?? '').trim() !== '';

        if (isInternacional) {
            // "não utilizarei a viagem" também precisa de justificativa — vai na observação de aéreo
            // (mesmo campo lido no relatório/planilha/carta), sem virar pedido de nova opção. Quem já tem
            // motivo gravado chega com ele preenchido (o buscar() não descarta justificativa) e passa.
            if (naoUtilizarViagem && !motivoIdaInformado) {
                toast.error(getText('informarMotivoNaoUtilizarViagem'));
                return false;
            }

            if (!naoUtilizarViagem && !temPassaporteArquivo) {
                toast.error(getText('requiredCopiaPassaporte'));
                return false;
            }

            // Internacional: aceitar se selecionou voo OU se informou motivo sem selecionar OU "não utilizarei a viagem"
            const selecionouVoo = (escolhaIda !== null || trechoIdaTravado) && (escolhaRetorno !== null || trechoRetornoTravado);
            const semSelecaoComMotivo = !selecionouVoo && motivoIdaInformado;
            if (!naoUtilizarViagem && !selecionouVoo && !semSelecaoComMotivo) {
                // Nenhuma escolha e nenhum motivo
                toast.error(getText('informarMotivoIda'));
                return false;
            }
        } else {
            // Nacional: regras originais
            if (!trechoIdaTravado && !aereoNaoAtendeIda && !naoUtilizarIda && escolhaIda === null) {
                toast.error(getText('escolherOpcaoIda'));
                return false;
            }

            if (!trechoRetornoTravado && !aereoNaoAtendeVolta && !naoUtilizarVolta && escolhaRetorno === null) {
                toast.error(getText('escolherOpcaoVolta'));
                return false;
            }

            if (!trechoIdaTravado && aereoNaoAtendeIda && !motivoIdaInformado) {
                toast.error(getText('informarMotivoIda'));
                return false;
            }

            if (!trechoRetornoTravado && aereoNaoAtendeVolta && !motivoVoltaInformado) {
                toast.error(getText('informarMotivoVolta'));
                return false;
            }

            // "não utilizarei esse trecho" exige justificativa. Quem já tem motivo gravado chega com ele
            // preenchido (o buscar() não descarta justificativa) e passa direto — ver acima.
            if (!trechoIdaTravado && naoUtilizarIda && !motivoIdaInformado) {
                toast.error(getText('informarMotivoNaoUtilizarIda'));
                return false;
            }

            if (!trechoRetornoTravado && naoUtilizarVolta && !motivoVoltaInformado) {
                toast.error(getText('informarMotivoNaoUtilizarVolta'));
                return false;
            }
        }

        if ((data?.evento?.camposQuestionario?.bagagemDespachada ?? "nao") === "sim") {
            var bagagemDespachada = document.querySelector("#bagagemDespachada");
            if ((data?.bagagemDespachada ?? '') === '') {
                toast.error(getText('preencherBagagem'));
                setTimeout(() => {
                    bagagemDespachada.focus();
                }, 500);
                return false;
            }
        }

        let confirmacao;

        // Caso de motivo sem seleção (internacional) também deve cair no fluxo de "analisar solicitação".
        // "Não utilizarei a viagem" fica de fora: também tem motivo preenchido, mas é escolha terminal —
        // não há solicitação a analisar nem retorno de contato.
        const semSelecaoComMotivoInternacional = isInternacional && !naoUtilizarViagem && escolhaIda === null && !trechoIdaTravado && motivoIdaInformado;

        if ((!trechoIdaTravado && aereoNaoAtendeIda) || semSelecaoComMotivoInternacional) {
            confirmacao = await new Promise((resolve) => {
                Alert({
                    icon: "info",
                    confirmButton: <><FaThumbsUp size={20} /> OK</>,
                    confirmButtonColor: "success",
                    title: getText('atencao'),
                    html: <>
                        <p>{getText('analisarSolicitacao')}</p>
                    </>,
                    callBack: (result) => {
                        resolve(result.isConfirmed);
                    }
                });
            });
        } else {
            //popup para confirmar a cidade de embarque
            const cidadeEmbarque = cidadeOrigem || opcaoIdaSalva?.idaorigem || data?.aereoidaorigem || '';
            confirmacao = await new Promise((resolve) => {
                Alert({
                    icon: "info",
                    confirmButton: <><FaThumbsUp size={20} /> {getText('confirmar')}</>,
                    cancelButton: getText('cancelar'),
                    cancelButtonColor: "danger",
                    confirmButtonColor: "success",
                    title: getText('atencao'),
                    html: <>
                        {cidadeEmbarque ? <p>{getText('confirmarAeroporto')} <strong>{cidadeEmbarque}</strong></p> : null}
                        <p>{getText('opcaoVooEscolhida')}</p>
                    </>,
                    callBack: (result) => {
                        resolve(result.isConfirmed);
                    }
                });
            });
        }

        if (!confirmacao) {
            return false;
        }

        // Equipe trocando o voo de quem já foi enviado para emissão: não bloqueia (há casos em que
        // o convidado precisa), mas confirma. Não há aviso por e-mail: a troca vai ao Aéreo na próxima
        // requisição do RSVP. O convidado nunca vê esta confirmação — ela é da operação interna.
        if (PERFIS_EQUIPE_EMISSAO.includes(perfil)) {
            const enviado = await api({ method: 'get', action: '/eventoAereoEmissaoParticipante', token, params: { participante: id } })
                .then(r => !!r?.data?.data?.enviado)
                .catch(() => false);
            if (enviado) {
                const segue = await new Promise((resolve) => {
                    Alert({
                        icon: "warning",
                        confirmButton: <><FaThumbsUp size={20} /> Salvar</>,
                        cancelButton: "Voltar",
                        cancelButtonColor: "danger",
                        confirmButtonColor: "success",
                        title: "Participante já enviado para emissão",
                        html: <>
                            <p>Trocar o voo depois do envio não é o fluxo ideal.</p>
                            <p><strong>A troca vai ao Aéreo na próxima requisição do RSVP.</strong></p>
                        </>,
                        callBack: (result) => resolve(result.isConfirmed),
                    });
                });
                if (!segue) {
                    return false;
                }
            }
        }

        return true;
    };

    const salvar = async () => {
        var idEvento = data?.evento.id;

        if (!(await validar())) {
            return false;
        }

        setIsSubmitting(true);
        // usa o isInternacional override-aware do escopo do componente (inclui participante inglês)
        const escolhaIdaRetorno = getIdaRetornoSelecionado();
        // No internacional a escolha é ida+volta junta e a tela só oferece "não utilizarei a viagem", então
        // o envio não pode carregar meia marcação. Ela é possível: o checkbox das telas internas é por
        // trecho, e um trecho marcado sozinho fazia o back ler a objeção do convidado como justificativa —
        // confirmando ele sem voo em vez de deixar pendente.
        const naoUtilizarViagem = isInternacional && naoUtilizarIda && naoUtilizarVolta;
        const recusaIda = isInternacional ? naoUtilizarViagem : naoUtilizarIda;
        const recusaRetorno = isInternacional ? naoUtilizarViagem : naoUtilizarVolta;
        // "não utilizarei esse trecho" nunca leva voo — força escolha nula pra esse lado.
        const escolhaIda = recusaIda ? null : (isInternacional ? escolhaIdaRetorno : (marcadoIda ?? getOpcaoIdaSalva()?.id ?? null));
        const escolhaRetorno = recusaRetorno ? null : (isInternacional ? escolhaIda : (marcadoRetorno ?? getOpcaoRetornoSalva()?.id ?? null));
        const formData = new FormData();

        if (escolhaIda) {
            formData.append('escolhaaereoida', escolhaIda);
        }

        if (escolhaRetorno) {
            formData.append('escolhaaereoretorno', escolhaRetorno);
        }

        // No internacional a recusa é da viagem inteira, então o mesmo motivo vai nos dois trechos —
        // o back valida trecho a trecho. Gravar um ou dois iguais dá na mesma.
        const motivoIda = data?.aereoidaobservacao ?? '';
        const motivoRetorno = data?.aereoretornoobservacao ?? '';
        const motivoViagem = motivoIda || motivoRetorno;
        formData.append('aereoidaobservacao', naoUtilizarViagem ? motivoViagem : motivoIda);
        formData.append('aereoretornoobservacao', naoUtilizarViagem ? motivoViagem : motivoRetorno);
        formData.append('naoutilizaraereoida', recusaIda ? 1 : 0);
        formData.append('naoutilizaraereoretorno', recusaRetorno ? 1 : 0);
        formData.append('bagagemDespachada', data?.bagagemDespachada ?? '');
        // A marcação de ciência dos documentos precisa ser PERSISTIDA, não reconstruída depois: o
        // e-mail de confirmação afirma a ciência em primeira pessoa e só pode afirmar o que o
        // convidado de fato marcou nesta tela.
        formData.append('documentosEntradaPaisCiente', documentosEntradaPaisCiente ? 1 : 0);
        formData.append('pendenciadocumentosentradapais', pendenciaDocumentosEntradaPais);

        if (arquivoPassaporte instanceof File) {
            formData.append('passaporte', arquivoPassaporte);
        }

        api({
            method: 'post',
            action: '/participante/escolhaAereo/' + id,
            token: token,
            data: formData,
        })
            .then(function (response) {
                toast.success(getText('dadosSalvosSucesso'));
                if (response?.data?.data) {
                    setData((prevData) => ({
                        ...prevData,
                        ...response.data.data,
                        passaporteArquivo: response?.data?.data?.passaportearquivo ?? prevData?.passaporteArquivo ?? null,
                    }));
                }

                setArquivoPassaporte(null);
                //o back resolve a próxima etapa com o estado fresco pós-save (overlay de load durante o GET).
                irParaProximoStep(history, { id, token, eventoId: idEvento, contrato, setLoading: setIsLoading });
            })
            .catch(function (error) {
                // 409 = a opção de aéreo escolhida não existe mais (operador re-salvou os voos com a tela
                // aberta). Pedir para recarregar a página em vez de mostrar o erro genérico de salvamento.
                if (error?.response?.status === 409) {
                    toast.error(`${getText('error')}${getText('errorRefreshPage')}`);
                } else if (error?.response?.data?.code === 'pendencia_documentos_nao_informada') {
                    // A tela já exige a declaração antes de enviar, então este 400 só chega de aba aberta
                    // antes do campo existir: recarregar faz o campo aparecer, o erro genérico não ajudaria.
                    toast.error(`${getText('requiredPendenciaDocumentos')}${getText('errorRefreshPage')}`);
                } else {
                    toast.error(`${getText('error')} ${getText('errorSavingDefault')}`);
                }
            })
            .finally(() => {
                setIsSubmitting(false);
            });
    }; //salvar

    useEffect(() => { //onload
        buscar();
    },
        // eslint-disable-next-line
        []);

    const opcaoIdaSalva = getOpcaoIdaSalva();
    const opcaoRetornoSalva = getOpcaoRetornoSalva();
    const trechoIdaTravado = !!opcaoIdaSalva;
    const trechoRetornoTravado = !!opcaoRetornoSalva;
    // "não utilizarei" já GRAVADO trava o trecho (radios desabilitados), igual a um voo salvo.
    // Usa o valor persistido (data.*), não o state transitório — antes de salvar o convidado ainda
    // pode trocar de ideia.
    const naoUtilizarIdaSalvo = !!data?.naoutilizaraereoida;
    const naoUtilizarVoltaSalvo = !!data?.naoutilizaraereoretorno;
    const idaBloqueada = trechoIdaTravado || naoUtilizarIdaSalvo;
    const voltaBloqueada = trechoRetornoTravado || naoUtilizarVoltaSalvo;
    // Internacional: a seleção é ida+volta junta, então "não utilizarei a viagem" = as duas flags.
    const naoUtilizarViagem = naoUtilizarIda && naoUtilizarVolta;
    const naoUtilizarViagemSalvo = naoUtilizarIdaSalvo && naoUtilizarVoltaSalvo;
    const idaSelecionada = marcadoIda ?? opcaoIdaSalva?.id ?? null;
    const retornoSelecionado = marcadoRetorno ?? opcaoRetornoSalva?.id ?? null;
    const idaRetornoSelecionado = getIdaRetornoSelecionado();
    const trechosInternacionaisTravados = trechoIdaTravado && trechoRetornoTravado;
    const internacionalBloqueado = trechosInternacionaisTravados || naoUtilizarViagemSalvo;
    const opcaoIdaSalvaForaDaLista = trechoIdaTravado
        && opcaoIdaSalva?.fromParticipante
        && !(data?.evento?.eventoaereo ?? []).some((opcao) => String(opcao.id) === String(opcaoIdaSalva?.id));
    const opcaoRetornoSalvaForaDaLista = trechoRetornoTravado
        && opcaoRetornoSalva?.fromParticipante
        && !(data?.evento?.eventoaereo ?? []).some((opcao) => String(opcao.id) === String(opcaoRetornoSalva?.id));
    const opcaoInternacionalSalvaNaLista = trechosInternacionaisTravados
        && opcaoIdaSalva?.fromParticipante
        && opcaoRetornoSalva?.fromParticipante
        && (data?.evento?.eventoaereo ?? []).some((opcao) => (
            String(opcao.id) === String(opcaoIdaSalva?.id)
            && String(opcao.id) === String(opcaoRetornoSalva?.id)
        ));
    const opcaoInternacionalSalvaForaDaLista = trechosInternacionaisTravados
        && opcaoIdaSalva?.fromParticipante
        && opcaoRetornoSalva?.fromParticipante
        && !opcaoInternacionalSalvaNaLista;

    return (
        <ErpTemplate sidebar={['listarsvp', 'cliente'].includes(perfil) ? false : true} processando={isLoading} idioma={idioma ?? "both"}>
            <div className="main-content container-fluid fin-pp">
                {!isLoading && !isError && data?.evento?.id && <>
                <div className="fin-pp__head">
                    <div>
                        <h2 className="fin-pp__title">{getText('escolhaAereo')}</h2>
                    </div>
                    <div className="fin-pp__actions">
                        <button type="button" className="fin-pp__btn fin-pp__btn--primary fin-pp__btn--pill" onClick={salvar} disabled={isSubmitting}>
                            {isSubmitting ? getText('salvando') : getText('salvar')}
                        </button>
                    </div>
                </div>
                <form onSubmit={(e) => { salvar(); e.preventDefault(); }}>
                    {(!isInternacional) ? (
                        <>
                            {/* Card ida */}
                            <div className="fin-pp__card" style={{ padding: '12px 16px', marginBottom: 16 }}>
                                <div className="fin-pp__cphead">
                                    <span className="fin-pp__cphead-title">{getText('ida')} <FaPlaneDeparture size={15} /></span>
                                </div>
                                <div className="fin-pp__tblwrap d-none d-md-block">
                                    <table className="fin-pp__tbl fin-pp__tbl--aereo">
                                        <thead>
                                            <tr>
                                                <th></th>
                                                <th>{getText('data')}</th>
                                                <th>{getText('cia')}</th>
                                                <th>{getText('voo')}</th>
                                                <th>{getText('origem')}</th>
                                                <th>{getText('destino')}</th>
                                                <th>{getText('saida')}</th>
                                                <th>{getText('chegada')}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {data?.evento?.eventoaereo ? data?.evento.eventoaereo.filter(idaTemDados).map((row, rowIndex) => (
                                                <tr key={rowIndex}>
                                                    <td width="5px">
                                                        <input type="radio"
                                                            name='idAereoIda'
                                                            checked={String(row.id) === String(idaSelecionada)}
                                                            disabled={idaBloqueada}
                                                            onChange={(value) => {
                                                                setMarcadoIda(row.id);
                                                                setCidadeOrigem(row.idaorigem);
                                                                setAereoNaoAtendeIda(false);
                                                                setNaoUtilizarIda(false);
                                                                setData({ ...data, aereoidaobservacao: "" });
                                                            }} />
                                                    </td>
                                                    <td>{renderCampoAereo(row.idadata)}</td>
                                                    <td>{renderCampoAereo(row.idacompanhia)}</td>
                                                    <td>{renderCampoAereo(row.idavoo)}</td>
                                                    <td><LocalAereo valor={row.idaorigem} /></td>
                                                    <td><LocalAereo valor={row.idadestino} /></td>
                                                    <td>{renderCampoAereo(row.idahorasaida)}</td>
                                                    <td>{renderCampoAereo(row.idahorachegada)}</td>
                                                </tr>
                                            )) : null}
                                            {opcaoIdaSalvaForaDaLista && (
                                                <tr>
                                                    <td><input type="radio" checked disabled /></td>
                                                    <td>{renderCampoAereo(opcaoIdaSalva.idadata)}</td>
                                                    <td>{renderCampoAereo(opcaoIdaSalva.idacompanhia)}</td>
                                                    <td>{renderCampoAereo(opcaoIdaSalva.idavoo)}</td>
                                                    <td><LocalAereo valor={opcaoIdaSalva.idaorigem} /></td>
                                                    <td><LocalAereo valor={opcaoIdaSalva.idadestino} /></td>
                                                    <td>{renderCampoAereo(opcaoIdaSalva.idahorasaida)}</td>
                                                    <td>{renderCampoAereo(opcaoIdaSalva.idahorachegada)}</td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                                <div className="aereo-opc d-md-none">
                                    {data?.evento?.eventoaereo ? data?.evento.eventoaereo.filter(idaTemDados).map((row) => (
                                        renderCardNacional({
                                            key: row.id,
                                            row,
                                            prefixo: 'ida',
                                            checked: String(row.id) === String(idaSelecionada),
                                            disabled: idaBloqueada,
                                            onSelect: () => {
                                                setMarcadoIda(row.id);
                                                setCidadeOrigem(row.idaorigem);
                                                setAereoNaoAtendeIda(false);
                                                setNaoUtilizarIda(false);
                                                setData({ ...data, aereoidaobservacao: "" });
                                            },
                                        })
                                    )) : null}
                                    {opcaoIdaSalvaForaDaLista && renderCardNacional({
                                        key: 'ida-salva',
                                        row: opcaoIdaSalva,
                                        prefixo: 'ida',
                                        checked: true,
                                        disabled: true,
                                    })}
                                </div>
                                {!idaBloqueada && (
                                    <div style={{ marginTop: 8 }}>
                                        <label>
                                            <input type="radio" name='idAereoIda' checked={aereoNaoAtendeIda}
                                                onChange={(e) => {
                                                    setAereoNaoAtendeIda(true);
                                                    setNaoUtilizarIda(false);
                                                    setMarcadoIda(null);
                                                    // marcação nova zera o texto da opção anterior, igual às outras
                                                    setData({ ...data, aereoidaobservacao: "" });
                                                }} />
                                            {' '}{getText('aereoNaoAtende')}
                                        </label>
                                    </div>
                                )}
                                {!trechoIdaTravado && (
                                    <div style={{ marginTop: 8 }}>
                                        <label>
                                            <input type="radio" name='idAereoIda' checked={naoUtilizarIda} disabled={naoUtilizarIdaSalvo}
                                                onChange={(e) => {
                                                    setNaoUtilizarIda(true);
                                                    setAereoNaoAtendeIda(false);
                                                    setMarcadoIda(null);
                                                    setData({ ...data, aereoidaobservacao: "" });
                                                }} />
                                            {' '}{getText('naoUtilizarTrecho')}
                                        </label>
                                    </div>
                                )}
                                {/* justificativa obrigatória do trecho recusado — mesma observação lida no
                                    relatório/planilha/carta, aqui como motivo e não como objeção. Mesmo
                                    comportamento do campo do "aéreo não me atende": aparece enquanto a
                                    opção estiver marcada. */}
                                {naoUtilizarIda && (
                                    <textarea className="fin-pp__input" id="naoutilizaridaobservacao"
                                        placeholder={getText('motivoNaoUtilizarTrecho')}
                                        style={{ height: 'auto', padding: '10px 14px', minHeight: '100px', marginTop: 8 }}
                                        value={data?.aereoidaobservacao ?? ''}
                                        onChange={e => setData({ ...data, "aereoidaobservacao": e.target.value })} />
                                )}
                                {aereoNaoAtendeIda && (
                                    <textarea className="fin-pp__input" id="aereoidaobservacao"
                                        placeholder={getText('motivoAereoIda')}
                                        style={{ height: 'auto', padding: '10px 14px', minHeight: '100px', marginTop: 8 }}
                                        value={data.aereoidaobservacao}
                                        onChange={e => {
                                            setData({ ...data, "aereoidaobservacao": e.target.value });
                                            if (e.target.value.length > 0) setMarcadoIda(null);
                                        }} />
                                )}
                            </div>

                            {/* Card volta */}
                            <div className="fin-pp__card" style={{ padding: '12px 16px', marginBottom: 16 }}>
                                <div className="fin-pp__cphead">
                                    <span className="fin-pp__cphead-title">{getText('volta')} <FaPlaneArrival size={15} /></span>
                                </div>
                                <div className="fin-pp__tblwrap d-none d-md-block">
                                    <table className="fin-pp__tbl fin-pp__tbl--aereo">
                                        <thead>
                                            <tr>
                                                <th></th>
                                                <th>{getText('data')}</th>
                                                <th>{getText('cia')}</th>
                                                <th>{getText('voo')}</th>
                                                <th>{getText('origem')}</th>
                                                <th>{getText('destino')}</th>
                                                <th>{getText('saida')}</th>
                                                <th>{getText('chegada')}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {data?.evento?.eventoaereo ? data?.evento.eventoaereo.filter(retornoTemDados).map((row, rowIndex) => (
                                                <tr key={rowIndex}>
                                                    <td width="5px">
                                                        <input type="radio" name='idAereoRetorno'
                                                            checked={String(row.id) === String(retornoSelecionado)}
                                                            disabled={voltaBloqueada}
                                                            onChange={(value) => {
                                                                setMarcadoRetorno(row.id);
                                                                setAereoNaoAtendeVolta(false);
                                                                setNaoUtilizarVolta(false);
                                                                setData({ ...data, aereoretornoobservacao: "" });
                                                            }} />
                                                    </td>
                                                    <td>{renderCampoAereo(row.retornodata)}</td>
                                                    <td>{renderCampoAereo(row.retornocompanhia)}</td>
                                                    <td>{renderCampoAereo(row.retornovoo)}</td>
                                                    <td><LocalAereo valor={row.retornoorigem} /></td>
                                                    <td><LocalAereo valor={row.retornodestino} /></td>
                                                    <td>{renderCampoAereo(row.retornohorasaida)}</td>
                                                    <td>{renderCampoAereo(row.retornohorachegada)}</td>
                                                </tr>
                                            )) : null}
                                            {opcaoRetornoSalvaForaDaLista && (
                                                <tr>
                                                    <td><input type="radio" checked disabled /></td>
                                                    <td>{renderCampoAereo(opcaoRetornoSalva.retornodata)}</td>
                                                    <td>{renderCampoAereo(opcaoRetornoSalva.retornocompanhia)}</td>
                                                    <td>{renderCampoAereo(opcaoRetornoSalva.retornovoo)}</td>
                                                    <td><LocalAereo valor={opcaoRetornoSalva.retornoorigem} /></td>
                                                    <td><LocalAereo valor={opcaoRetornoSalva.retornodestino} /></td>
                                                    <td>{renderCampoAereo(opcaoRetornoSalva.retornohorasaida)}</td>
                                                    <td>{renderCampoAereo(opcaoRetornoSalva.retornohorachegada)}</td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                                <div className="aereo-opc d-md-none">
                                    {data?.evento?.eventoaereo ? data?.evento.eventoaereo.filter(retornoTemDados).map((row) => (
                                        renderCardNacional({
                                            key: row.id,
                                            row,
                                            prefixo: 'retorno',
                                            checked: String(row.id) === String(retornoSelecionado),
                                            disabled: voltaBloqueada,
                                            onSelect: () => {
                                                setMarcadoRetorno(row.id);
                                                setAereoNaoAtendeVolta(false);
                                                setNaoUtilizarVolta(false);
                                                setData({ ...data, aereoretornoobservacao: "" });
                                            },
                                        })
                                    )) : null}
                                    {opcaoRetornoSalvaForaDaLista && renderCardNacional({
                                        key: 'retorno-salva',
                                        row: opcaoRetornoSalva,
                                        prefixo: 'retorno',
                                        checked: true,
                                        disabled: true,
                                    })}
                                </div>
                                {!voltaBloqueada && (
                                    <div style={{ marginTop: 8 }}>
                                        <label>
                                            <input type="radio" name='idAereoRetorno' checked={aereoNaoAtendeVolta}
                                                onChange={(e) => {
                                                    setAereoNaoAtendeVolta(true);
                                                    setNaoUtilizarVolta(false);
                                                    setMarcadoRetorno(null);
                                                    // marcação nova zera o texto da opção anterior, igual às outras
                                                    setData({ ...data, aereoretornoobservacao: "" });
                                                }} />
                                            {' '}{getText('aereoNaoAtende')}
                                        </label>
                                    </div>
                                )}
                                {!trechoRetornoTravado && (
                                    <div style={{ marginTop: 8 }}>
                                        <label>
                                            <input type="radio" name='idAereoRetorno' checked={naoUtilizarVolta} disabled={naoUtilizarVoltaSalvo}
                                                onChange={(e) => {
                                                    setNaoUtilizarVolta(true);
                                                    setAereoNaoAtendeVolta(false);
                                                    setMarcadoRetorno(null);
                                                    setData({ ...data, aereoretornoobservacao: "" });
                                                }} />
                                            {' '}{getText('naoUtilizarTrecho')}
                                        </label>
                                    </div>
                                )}
                                {/* justificativa obrigatória do trecho recusado — ver comentário do trecho de ida */}
                                {naoUtilizarVolta && (
                                    <textarea className="fin-pp__input" id="naoutilizarretornoobservacao"
                                        placeholder={getText('motivoNaoUtilizarTrecho')}
                                        style={{ height: 'auto', padding: '10px 14px', minHeight: '100px', marginTop: 8 }}
                                        value={data?.aereoretornoobservacao ?? ''}
                                        onChange={e => setData({ ...data, "aereoretornoobservacao": e.target.value })} />
                                )}
                                {aereoNaoAtendeVolta && (
                                    <textarea className="fin-pp__input" id="aereoretornoobservacao"
                                        placeholder={getText('motivoAereoVolta')}
                                        style={{ height: 'auto', padding: '10px 14px', minHeight: '100px', marginTop: 8 }}
                                        value={data?.aereoretornoobservacao}
                                        onChange={e => {
                                            setData({ ...data, "aereoretornoobservacao": e.target.value });
                                            if (e.target.value.length > 0) setMarcadoRetorno(null);
                                        }} />
                                )}
                            </div>
                        </>
                    ) : (
                        /* INTERNACIONAL: card único com tabela ida+retorno */
                        <div className="fin-pp__card" style={{ padding: '12px 16px', marginBottom: 16 }}>
                            <div className="fin-pp__tblwrap d-none d-md-block">
                                <table className="fin-pp__tbl fin-pp__tbl--aereo">
                                    <thead>
                                        <tr>
                                            <th></th>
                                            <th></th>
                                            <th>{getText('data')}</th>
                                            <th>{getText('cia')}</th>
                                            <th>{getText('voo')}</th>
                                            <th>{getText('origem')}</th>
                                            <th>{getText('destino')}</th>
                                            <th>{getText('saida')}</th>
                                            <th>{getText('chegada')}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {data?.evento?.eventoaereo ? data?.evento.eventoaereo.filter(row => idaTemDados(row) || retornoTemDados(row)).map((row, rowIndex) => (
                                            <React.Fragment key={rowIndex}>
                                                <tr className='lenteCinza'>
                                                    <td width="5px" rowSpan={2}>
                                                        <input type="radio" name='idAereoIda'
                                                            checked={String(row.id) === String(idaRetornoSelecionado)}
                                                            disabled={internacionalBloqueado}
                                                            onChange={(value) => {
                                                                setMarcadoRetorno(row.id);
                                                                setMarcadoIda(row.id);
                                                                setNaoUtilizarIda(false);
                                                                setNaoUtilizarVolta(false);
                                                                setData(prevData => ({ ...prevData, aereoidaobservacao: "", aereoretornoobservacao: "" }))
                                                            }} />
                                                    </td>
                                                    <td>{getText('ida')}</td>
                                                    <td>{(row.idadata ?? '').split("|").map((valor, i) => <React.Fragment key={i}>{valor}<br /></React.Fragment>)}</td>
                                                    <td>{(row.idacompanhia ?? '').split("|").map((valor, i) => <React.Fragment key={i}>{valor}<br /></React.Fragment>)}</td>
                                                    <td>{(row.idavoo ?? '').split("|").map((valor, i) => <React.Fragment key={i}>{valor}<br /></React.Fragment>)}</td>
                                                    <td><LocalAereo valor={row.idaorigem} /></td>
                                                    <td><LocalAereo valor={row.idadestino} /></td>
                                                    <td>{(row.idahorasaida ?? '').split("|").map((valor, i) => <React.Fragment key={i}>{valor}<br /></React.Fragment>)}</td>
                                                    <td>{(row.idahorachegada ?? '').split("|").map((valor, i) => <React.Fragment key={i}>{valor}<br /></React.Fragment>)}</td>
                                                </tr>
                                                <tr className='lenteCinza'>
                                                    <td>{getText('retorno')}</td>
                                                    <td>{(row.retornodata ?? '').split("|").map((valor, i) => <React.Fragment key={i}>{valor}<br /></React.Fragment>)}</td>
                                                    <td>{(row.retornocompanhia ?? '').split("|").map((valor, i) => <React.Fragment key={i}>{valor}<br /></React.Fragment>)}</td>
                                                    <td>{(row.retornovoo ?? '').split("|").map((valor, i) => <React.Fragment key={i}>{valor}<br /></React.Fragment>)}</td>
                                                    <td><LocalAereo valor={row.retornoorigem} /></td>
                                                    <td><LocalAereo valor={row.retornodestino} /></td>
                                                    <td>{(row.retornohorasaida ?? '').split("|").map((valor, i) => <React.Fragment key={i}>{valor}<br /></React.Fragment>)}</td>
                                                    <td>{(row.retornohorachegada ?? '').split("|").map((valor, i) => <React.Fragment key={i}>{valor}<br /></React.Fragment>)}</td>
                                                </tr>
                                                <tr><th colSpan={9}></th></tr>
                                            </React.Fragment>
                                        )) : null}
                                        {opcaoInternacionalSalvaForaDaLista && (
                                            <React.Fragment>
                                                <tr className='lenteCinza'>
                                                    <td width="5px" rowSpan={2}><input type="radio" checked disabled /></td>
                                                    <td>{getText('ida')}</td>
                                                    <td>{renderCampoAereo(opcaoIdaSalva.idadata)}</td>
                                                    <td>{renderCampoAereo(opcaoIdaSalva.idacompanhia)}</td>
                                                    <td>{renderCampoAereo(opcaoIdaSalva.idavoo)}</td>
                                                    <td><LocalAereo valor={opcaoIdaSalva.idaorigem} /></td>
                                                    <td><LocalAereo valor={opcaoIdaSalva.idadestino} /></td>
                                                    <td>{renderCampoAereo(opcaoIdaSalva.idahorasaida)}</td>
                                                    <td>{renderCampoAereo(opcaoIdaSalva.idahorachegada)}</td>
                                                </tr>
                                                <tr className='lenteCinza'>
                                                    <td>{getText('retorno')}</td>
                                                    <td>{renderCampoAereo(opcaoRetornoSalva.retornodata)}</td>
                                                    <td>{renderCampoAereo(opcaoRetornoSalva.retornocompanhia)}</td>
                                                    <td>{renderCampoAereo(opcaoRetornoSalva.retornovoo)}</td>
                                                    <td><LocalAereo valor={opcaoRetornoSalva.retornoorigem} /></td>
                                                    <td><LocalAereo valor={opcaoRetornoSalva.retornodestino} /></td>
                                                    <td>{renderCampoAereo(opcaoRetornoSalva.retornohorasaida)}</td>
                                                    <td>{renderCampoAereo(opcaoRetornoSalva.retornohorachegada)}</td>
                                                </tr>
                                                <tr><th colSpan={9}></th></tr>
                                            </React.Fragment>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                            <div className="aereo-opc d-md-none">
                                {data?.evento?.eventoaereo ? data?.evento.eventoaereo.filter(row => idaTemDados(row) || retornoTemDados(row)).map((row) => (
                                    renderCardInternacional({
                                        key: row.id,
                                        idaRow: row,
                                        checked: String(row.id) === String(idaRetornoSelecionado),
                                        disabled: internacionalBloqueado,
                                        onSelect: () => {
                                            setMarcadoRetorno(row.id);
                                            setMarcadoIda(row.id);
                                            setNaoUtilizarIda(false);
                                            setNaoUtilizarVolta(false);
                                            setData(prevData => ({ ...prevData, aereoidaobservacao: "", aereoretornoobservacao: "" }));
                                        },
                                    })
                                )) : null}
                                {opcaoInternacionalSalvaForaDaLista && renderCardInternacional({
                                    key: 'internacional-salva',
                                    idaRow: opcaoIdaSalva,
                                    retornoRow: opcaoRetornoSalva,
                                    checked: true,
                                    disabled: true,
                                })}
                            </div>
                            {!trechosInternacionaisTravados && (
                                <div style={{ marginTop: 12 }}>
                                    <label>
                                        <input type="radio" name='idAereoIda' checked={naoUtilizarViagem} disabled={naoUtilizarViagemSalvo}
                                            onChange={(e) => {
                                                setNaoUtilizarIda(true);
                                                setNaoUtilizarVolta(true);
                                                setMarcadoIda(null);
                                                setMarcadoRetorno(null);
                                                setData({ ...data, aereoidaobservacao: "", aereoretornoobservacao: "" });
                                            }} />
                                        {' '}{getText('naoUtilizarViagem')}
                                    </label>
                                </div>
                            )}
                            {/* justificativa obrigatória da viagem recusada. No internacional a escolha é
                                ida+volta junta, então o motivo vai nas DUAS observações — é o que o
                                relatório/planilha/carta lê por trecho. */}
                            {naoUtilizarViagem && (
                                <textarea className="fin-pp__input" id="naoutilizarviagemobservacao"
                                    placeholder={getText('motivoNaoUtilizarViagem')}
                                    style={{ height: 'auto', padding: '10px 14px', minHeight: '100px', marginTop: 12 }}
                                    value={data?.aereoidaobservacao ?? ''}
                                    onChange={e => setData({ ...data, "aereoidaobservacao": e.target.value, "aereoretornoobservacao": e.target.value })} />
                            )}
                            {!naoUtilizarViagem && (
                                <div style={{ marginTop: 12 }}>
                                    <label>{getText('opcaoVooNaoAtende')}</label>
                                    <textarea disabled={internacionalBloqueado}
                                        className="fin-pp__input" id="aereoidaobservacao"
                                        placeholder={getText('motivo')}
                                        style={{ height: 'auto', padding: '10px 14px', minHeight: '100px', marginTop: 8 }}
                                        value={data?.aereoidaobservacao}
                                        onChange={e => {
                                            setData({ ...data, "aereoidaobservacao": e.target.value });
                                            if (e.target.value.length > 0) { setMarcadoIda(null); setMarcadoRetorno(null); }
                                        }} />
                                </div>
                            )}
                        </div>
                    )}

                    {/* Bagagem despachada */}
                    {(data?.evento?.camposQuestionario?.bagagemDespachada ?? "nao") === "sim" && (
                        <div className="fin-pp__card" style={{ padding: '12px 16px', marginBottom: 16 }}>
                            <div className="fin-pp__filters">
                                <FinField label={getText('necessitaBagagem')}>
                                    <ReactSelect
                                        id={"bagagemDespachada"}
                                        value={{ value: data?.bagagemDespachada, label: data?.nomeBagagemDespachada }}
                                        onChange={e => setData({ ...data, "bagagemDespachada": e.value, "nomeBagagemDespachada": e.label })}
                                        options={[
                                            { value: "nao", label: getText('nao') },
                                            { value: "sim", label: getText('sim') },
                                        ]}
                                    />
                                </FinField>
                            </div>
                        </div>
                    )}

                    {/* Informações importantes */}
                    <div className="fin-pp__card" style={{ padding: '12px 16px', marginBottom: 16 }}>
                        <div className="fin-pp__cphead">
                            <span className="fin-pp__cphead-title">{getText('informacoesImportantesAereo')}</span>
                        </div>
                        <p>{getText('opcaoAereoEmissao')}</p>
                        <p>
                            <span style={{ fontStyle: 'italic' }}>{getText('documentacaoObrigatoria')}</span><br />
                            {(!isInternacional) ?
                                <strong>{getText('documentoNacional')}</strong>
                                :
                                <strong>
                                    {getText('documentoInternacional')}<br />
                                    {/* {getText('enviarCopiaDocumento')} {data?.evento?.emailremetente ?? ""} */}
                                </strong>
                            }
                        </p>
                        <p>
                            A {data?.evento?.cliente?.nomefantasia} {getText('responsabilidadePatrocinio')}<br />
                            {getText('alteracoesResponsabilidade')}
                        </p>
                        <p>
                            {getText('confirmarNomeDocumento')}<br />
                            {getText('informacaoImportante')}<br />
                            {getText('observacoesImportantes')}<br />
                            {getText('alteracaoAposEmissao')}
                            {isSanofiModelo && (
                                <><br />{getText('despesasAcompanhanteResponsabilidade')}<br />{getText('assinaturaSanofi')}</>
                            )}
                        </p>
                    </div>

                    {/* Documentos necessários para entrada no país */}
                    {(isInternacional && (data?.evento?.documentosnecessariosentradapais ?? '').trim() !== '') && (
                        <div className="fin-pp__card" style={{ padding: '12px 16px', marginBottom: 16 }}>
                            <div className="fin-pp__cphead">
                                <span className="fin-pp__cphead-title">{getText('documentosEntradaPaisTitulo')}</span>
                            </div>
                            <div className="alert alert-info">
                                <p style={{ whiteSpace: 'pre-line' }}>{data?.evento.documentosnecessariosentradapais}</p>
                            </div>
                            <label>
                                <input type="checkbox" checked={documentosEntradaPaisCiente}
                                    onChange={(e) => setDocumentosEntradaPaisCiente(e.target.checked)} />
                                {' '}{getText('cienteDocumentosEntradaPais')}
                            </label>

                            {/* Declaração escrita do que o convidado tem ou do que falta. Obrigatória: o
                                ciente sozinho não dizia NADA sobre a situação real dos documentos, e a
                                falta só aparecia no aeroporto. É o que o RSVP repassa ao laboratório. */}
                            <div style={{ marginTop: 12 }}>
                                <label htmlFor="pendenciadocumentosentradapais">
                                    {getText('especificarDocumentosEntradaPais')} <span style={{ color: 'var(--fin-dg)' }}>*</span>
                                </label>
                                <textarea className="fin-pp__input" id="pendenciadocumentosentradapais"
                                    style={{ height: 'auto', padding: '10px 14px', minHeight: '100px', marginTop: 8 }}
                                    value={pendenciaDocumentosEntradaPais}
                                    onChange={(e) => setPendenciaDocumentosEntradaPais(e.target.value)} />
                                <div style={{ marginTop: 8, fontStyle: 'italic' }}>
                                    {getText('informaremosLaboratorioPendencias')}
                                </div>
                            </div>
                        </div>
                    )}

                    {/* Passaporte (internacional) */}
                    {isInternacional && (
                        <div className="fin-pp__card" style={{ padding: '12px 16px', marginBottom: 16 }}>
                            <div className="fin-pp__cphead">
                                <span className="fin-pp__cphead-title">{getText('passaporte_label')}</span>
                            </div>
                            <div className='px-4 py-2'>
                                <UploadDropzone
                                    value={arquivoPassaporte ?? data?.passaporteArquivo ?? null}
                                    onChange={setArquivoPassaporte}
                                    title={getText('uploadArquivo')}
                                    accept=".pdf,.jpg,.jpeg,.png"
                                />
                            </div>
                            {data?.passaporteArquivo?.id && !arquivoPassaporte ? (
                                <div className='w-100 text-center text-muted'>
                                    <strong>{getText('arquivoAtual')}</strong>
                                    <a href={`${process.env.REACT_APP_API_URL}/arquivo/download/${data.passaporteArquivo.id}`}
                                        target="_blank" rel="noopener noreferrer"
                                        className="text-primary text-decoration-none ms-1">
                                        {data.passaporteArquivo.nome?.split('\\').pop().split('/').pop() || 'Baixar documento enviado'}
                                    </a>
                                </div>
                            ) : null}
                        </div>
                    )}
                </form>
                </>}
            </div>
        </ErpTemplate>
    );
}
